import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";
import { getLang } from "@/api/utils/apiHelper";

var VipGetReportBtn =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipGetReportBtn, _Vue);

  function VipGetReportBtn() {
    _classCallCheck(this, VipGetReportBtn);

    return _possibleConstructorReturn(this, _getPrototypeOf(VipGetReportBtn).apply(this, arguments));
  }

  _createClass(VipGetReportBtn, [{
    key: "buyVip",
    value: function () {
      var _buyVip = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit("buyVip");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buyVip() {
        return _buyVip.apply(this, arguments);
      }

      return buyVip;
    }()
  }, {
    key: "loadingBackground",
    // get isRenew() {
    //   return GeneralUtilsHelper.isRenew();
    // }
    get: function get() {
      return !this.tryContinue ? "#603BF3" : this.orange ? "linear-gradient(101.07deg, #FFB864 0%, #FF5C28 91.67%)" : "linear-gradient(82.58deg, #5d35fe -4.68%, #fb2a8e 104.87%)";
    }
  }, {
    key: "isItaly",
    get: function get() {
      return getLang() === "it";
    }
  }, {
    key: "isGerman",
    get: function get() {
      return getLang() === "de" || getLang() === "fr" || getLang() === "it";
    }
  }]);

  return VipGetReportBtn;
}(Vue);

tslib_1.__decorate([Prop({
  default: false
})], VipGetReportBtn.prototype, "freeText", void 0);

tslib_1.__decorate([Prop()], VipGetReportBtn.prototype, "getText", void 0);

tslib_1.__decorate([Prop({
  default: true
})], VipGetReportBtn.prototype, "showCharge", void 0);

tslib_1.__decorate([Prop({
  default: true
})], VipGetReportBtn.prototype, "tryContinue", void 0);

tslib_1.__decorate([Prop({
  default: true
})], VipGetReportBtn.prototype, "showArrow", void 0);

tslib_1.__decorate([Prop({
  default: false
})], VipGetReportBtn.prototype, "horoscope", void 0);

tslib_1.__decorate([Prop({
  default: true
})], VipGetReportBtn.prototype, "showLigth", void 0);

tslib_1.__decorate([Prop({
  default: false
})], VipGetReportBtn.prototype, "orange", void 0);

VipGetReportBtn = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton
  }
})], VipGetReportBtn);
export default VipGetReportBtn;